import {AgeGrade} from '../generated/types';

export function createContentAgeGrade(
  ageGrade?: AgeGrade,
  self_censorship?: boolean
): ContentAgeGrade {
  if (ageGrade === AgeGrade.All) {
    return ContentAgeGrade.All;
  }
  if (ageGrade === AgeGrade.Fifteen) {
    return ContentAgeGrade.Fifteen;
  }
  if (ageGrade === AgeGrade.Nineteen) {
    return self_censorship
      ? ContentAgeGrade.NineteenSelf
      : ContentAgeGrade.Nineteen;
  }
  return ContentAgeGrade.All;
}

export enum ContentAgeGrade {
  All = '전체',
  Fifteen = '15세 이용가',
  Nineteen = '19세 이용가',
  NineteenSelf = '19세 이용가(자율심의)',
}
